module.exports = "/static/images/trail-forest.webp";